import type { TranslateDictionary } from './en.js';

export const Tr: TranslateDictionary = {
  'Start airplay': "AirPlay'i başlat",
  'Stop airplay': "AirPlay'i durdur",
  Audio: 'Ses',
  Captions: 'Altyazılar',
  'Enable captions': 'Altyazıları etkinleştir',
  'Disable captions': 'Altyazıları devre dışı bırak',
  'Start casting': 'Yayını başlat',
  'Stop casting': 'Yayını durdur',
  'Casting to {device}': '{device} cihazına yayınlanıyor',
  'Enter fullscreen mode': 'Tam ekran yap',
  'Exit fullscreen mode': 'Tam ekrandan çık',
  Mute: 'Sessiz',
  Unmute: 'Sesi aç',
  'Enter picture in picture mode': 'Resim içinde resim modunu aç',
  'Exit picture in picture mode': 'Resim içinde resim modundan çık',
  Play: 'Oynat',
  Pause: 'Dondur',
  'Playback rate': 'Oynatma hızı',
  'Playback rate {playbackRate}': 'Oynatma hızı {playbackRate}',
  Quality: 'Kalite',
  'Seek backward': 'Geri sar',
  'Seek forward': 'İleri sar',
  Settings: 'Ayarlar',
  Auto: 'Otomatik',
  'audio player': 'ses oynatıcı',
  'video player': 'video oynatıcı',
  volume: 'Ses',
  seek: 'Ara',
  'closed captions': 'Kapalı altyazılar',
  'current playback rate': 'geçerli oynatma hızı',
  'playback time': 'oynatma süresi',
  'media loading': 'medya yükleniyor',
  settings: 'Ayarlar',
  'audio tracks': 'ses parçaları',
  quality: 'Kalite',
  play: 'oynat',
  pause: 'dondur',
  mute: 'sessiz',
  unmute: 'sesi aç',
  'chapter: {chapterName}': 'bölüm: {chapterName}',
  live: 'canlı',
  Off: 'Kapalı',
  'start airplay': "AirPlay'i başlat",
  'stop airplay': "AirPlay'i durdur",
  'start casting': 'yayını başlat',
  'stop casting': 'yayını durdur',
  'enter fullscreen mode': 'tam ekran yap',
  'exit fullscreen mode': 'tam ekrandan çık',
  'enter picture in picture mode': 'resim içinde resim modunu aç',
  'exit picture in picture mode': 'resim içinde resim modundan çık',
  'seek to live': 'canlı yayına git',
  'playing live': 'canlı oynatılıyor',
  'seek back {seekOffset} seconds': '{seekOffset} saniye geri sar',
  'seek forward {seekOffset} seconds': '{seekOffset} saniye ileri sar',
  'Network Error': 'Ağ Hatası',
  'Decode Error': 'Kod Çözme Hatası',
  'Source Not Supported': 'Kaynak Desteklenmiyor',
  'Encryption Error': 'Şifreleme Hatası',
  'A network error caused the media download to fail.':
    'Bir ağ hatası medya indirmesinin başarısız olmasına neden oldu.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Bir medya hatası oynatmanın iptal edilmesine neden oldu. Medya bozuk olabilir veya tarayıcınız bu formatı desteklemiyor olabilir.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Desteklenmeyen bir hata oluştu. Sunucu veya ağ başarısız oldu veya tarayıcınız bu formatı desteklemiyor.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Medya şifrelenmiş ve şifresini çözmek için anahtar yok.',
  'This video is not available.': 'Bu video kullanılamıyor.',
  'This video could not be found.': 'Bu video bulunamadı.',
};
